import { FC, HTMLAttributes } from 'react';

import TitleBarButton from './TitleBarButton';
import { IDataTestId, IDataTheme } from '@custom';

import './TitleBarButton.css';

type TProps = {
  showBackBtn: boolean;
} & IDataTestId &
  IDataTheme &
  HTMLAttributes<HTMLButtonElement>;

const BackButton: FC<TProps> = ({ showBackBtn, ...rest }) => {
  return <TitleBarButton hide={!showBackBtn} variant="back" buttonProps={rest} />;
};

export default BackButton;
